export const HEADER_EXPORT_BOOKAO = [
  "ID",
  "Bookão date",
  "Space name - Room Name",
  "Amount charged",
  "Take",
  "Capacity",
  "Credits",
  "Company",
  "Comission R$",
  "Transfer R$",
  "Status",
];

export const HEADER_EXPORT_PRIVATE_OFFICE_CONTRACTS = [
  "ID contrato",
  "ID empresa",
  "Empresa",
  "ID espaço ",
  "Espaço",
  "ID escritório",
  "Escritório",
  "Data início / fim",
  "Tipo de reserva",
  "Data de aniversário",
  "Índice de reajuste",
  "Tempo de uso do escritório",
  "Aviso prévio cliente",
  "Aviso prévio parceiro",
  "Status",
  "Motivo do cancelamento",
  "Data de cancelamento",
  "ID Pacote",
  "Créditos",
  "Take",
  "Repasse",
];
